import React, { Component } from 'react'
import { CustomInput, Label, Input, FormGroup, FormFeedback, Form } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import EirRecaptcha from '../eir-recaptcha/EirRecaptcha';


export class EirOnlineMedicalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transferAccount: false,
            closeAccount: false,
            isRequired: false,
            isDisabled: false,
            isAddDisabled: false,
            isCloseAccountDisabled: false,
            isTransferAccountDisabled: false,
            sending: false,
            emailvalue: '',
            isConfirmEmail: true,
            confirmEmail: '',
            countyList: [],
            response: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentWillMount = () => {

        fetch('/json/counties.txt')
            .then(res => res.json())
            .then(data => this.setState({ countyList: data }))
            

    }
    
    async handleSubmit(event) {
        let form = event.target;
        event.preventDefault();
        event.stopPropagation();
        form = $("form")[0];
        if (form.checkValidity() != false) {
            this.setState({
                sending: true
            });

            let response = await fetch(this.props.action,
                {
                    method: form.method,
                    body: new FormData($("form")[0])
                }
            );

            this.setState({
                response: (response.ok ? await response.json() : false),
                sending: false
            });
            if ((this.state.response != null && this.state.response.result.status == 'success') || (this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false))) {
                let scrollStep = -window.pageYOffset / (1000 / 15);
                let scrollInterval = setInterval(function () {
                    if (window.pageYOffset != 0) {
                        window.scrollBy(0, scrollStep);

                    } else clearInterval(scrollInterval);
                }, 15);
            }
        }
        form.classList.add('was-validated');
        if($('#attachment')[0] != undefined && $('#attachment')[0].files.length === 0){
            $('#attachment').focus();
        }
        if ($(".was-validated .form-control:invalid")[0] != undefined) {
            $(".was-validated .form-control:invalid")[0].focus();
        }
    }

    emailValue(feild_Id_One, feild_Id_Two) {
        let email = $('#' + feild_Id_One).val();
        let confirm_Email = $('#' + feild_Id_Two).val();

        if (email != "" && confirm_Email != "") {
            if (email == confirm_Email) {
                this.setState({
                    isConfirmEmail: true
                })
            }
            else {
                this.setState({
                    isConfirmEmail: false
                })
            }
        }
    }

    transferAccount = () => {
        this.setState({
            transferAccount: true,
            closeAccount: false,
            isCloseAccountDisabled: true,
            isTransferAccountDisabled: false

        })
    }

    closeAccount = () => {
        this.setState({
            closeAccount: true,
            transferAccount: false,
            isTransferAccountDisabled: true,
            isCloseAccountDisabled: false
        })
    }

    formgreyout = () => {
        this.setState({
            isDisabled: !this.state.isDisabled
        })
    }

    addressformgreyout = () => {
        this.setState({
            isAddDisabled: !this.state.isAddDisabled
        })

    }

    render() {

        const CList = this.state.countyList.counties;

        return (
            <div className="bereavement-forms">
                <div className="mb-5 mt-5 container d-flex flex-column align-items-center justify-content-center">
                    <h2>Medical Incapacitation</h2>
                    <p>&nbsp;</p>
                    <p>Letting us know about a change of account due to a medical reason.</p>
                    <p>We understand that this is a difficult time and we want to help you through your next steps with as much ease as possible.</p>
                    <p>That's why we have two ways that you can let us know about a change of account due to a medical reason. First you can use the below form, or if you'd prefer to talk, you can dial 1901 .</p>
                    <p>If you decide to use the form, we need you to help us resolve this query for you by answering a few simple questions.</p>
                </div>
                {(this.state.response == null && !this.state.sending) && (

                    <Form method="post" action={this.props.action} noValidate={false} className="needs-validation d-flex flex-column align-items-center justify-content-center" id="bereavement-form" onSubmit={this.handleSubmit} >                     
                        <Input type="hidden" value={this.props.email} id="Email_To_Address" name="Email_To_Address" />
                        <Input type="hidden" value="Medical Incapacitation Form" id="Email_Subject" name="Email_Subject" />
                        <Input type="hidden" value={this.props.formName} id="Form_Name" name="Form_Name" />

                        {/* Customer Identity */}
                        <Input type="hidden" value="Customer Identity:" id="Customer_Sub_Heading" name="Customer_Sub_Heading" />
                        <div className="customer-identity-container">
                            <h4>
                                Customer Identity:
                             </h4>
                            <FormGroup>
                                <Label>Customer's First Name<span className="mandatory">*</span></Label>
                                <Input name="Customers_First_Name" pattern="[a-zA-Z\s]+" type="text" id="Customers_First_Name" required />
                                <FormFeedback>Please enter first name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's Surname<span className="mandatory">*</span></Label>
                                <Input name="Customers_Sur_Name" pattern="[a-zA-Z\s]+" type="text" id="Customers_Sur_Name" required />
                                <FormFeedback>Please enter a name</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Telephone Number<span className="mandatory">*</span></Label>
                                <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Customers_Tel_No" id="Customers_Tel_No" required />
                                <FormFeedback>Please enter a valid telephone number</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Account Number<span className="mandatory">*</span></Label>
                                <Input type="text" name="Customers_Account_Number" id="Customers_Account_Number" required />
                                <FormFeedback>Please enter a valid account number</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's address line 1<span className="mandatory">*</span></Label>
                                <Input name="Customers_Address_One" type="text" id="Customers_Address_One" required />
                                <FormFeedback>Please enter address line 1 </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Customer's address line 2</Label>
                                <Input name="Customers_Address_Two" type="text" id="Customers_Address_Two" />
                            </FormGroup>
                            <FormGroup>
                                <Label>Town/City<span className="mandatory">*</span></Label>
                                <Input name="Customers_Town_City" type="text" id="Customers_Town_City" required />
                                <FormFeedback>Please enter Town/City</FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>County<span className="mandatory">*</span></Label>
                                <Input type="select" name="Customers_County" id="Customers_County" required>
                                <option value="">Select County</option>
                                {CList != undefined &&
                                    (CList.map((name, i) => <option key={name.name}>{name.name}</option>,))
                                    }
                                </Input>
                                <FormFeedback>Please enter county </FormFeedback>
                            </FormGroup>
                            <FormGroup>
                                <Label>Eircode<span className="mandatory">*</span></Label>
                                <Input name="Customers_Eircode" type="text" id="Customers_Eircode" minLength="7" maxLength="8" pattern="^[0-9a-zA-Z\s]*$" required />
                                <FormFeedback>Please enter Eircode </FormFeedback>
                            </FormGroup>

                            {/* Details of the Medical Incapacity issue  */}
                            <Input type="hidden" value="Details of the Medical Incapacity issue:" id="DC_Sub_Heading" name="DC_Sub_Heading" />
                            <h4>
                                Details of the Medical Incapacity issue:
                            </h4>
                            <FormGroup>
                                <Label>Outline of reason of change request<span className="mandatory">*</span></Label>
                                <Input name="Medical_Change_Request" type="textarea" id="Medical_Change_Request" required />
                                <FormFeedback>Please enter reason of change request</FormFeedback>
                            </FormGroup>

                            <FormGroup className="discription">
                                <Label>Attach a copy of the medical documentation<span className="mandatory">*</span> </Label>
                                <Input name="attachment" type="file" id="attachment" required />
                                <FormFeedback>Please attach a copy of the medical documentation</FormFeedback>
                            </FormGroup>                          
                            {/* Options to cancel or transfer account */}
                            <h4>
                                What would  you like to do next?
                            </h4>
                            <FormGroup tag="fieldset">
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" value="Close Account" name="New_Account_Status" onClick={this.closeAccount} required />{' '}
                                        Close Account
                                    </Label>
                                </FormGroup>
                                <FormGroup check>
                                    <Label check>
                                        <Input type="radio" value="Transfer Account" name="New_Account_Status" onClick={this.transferAccount} />{' '}
                                        Transfer Ownership
                                        <FormFeedback>Please choose one option</FormFeedback>
                                    </Label>
                                </FormGroup>
                            </FormGroup>

                            {this.state.closeAccount &&
                                <div>
                                    <h4>
                                        Details for closing account:
                                    </h4>
                                </div>
                            }

                            {this.state.transferAccount &&
                                <div>
                                    <h4>
                                        Details for transferring ownership:
                                    </h4>
                                </div>
                            }

                            {/* Executor’s Details */}
                            {this.state.closeAccount &&
                                <div>
                                    <Input type="hidden" value="Close Account Details:" id="Close_Sub_Heading" name="Close_Sub_Heading" />
                                    <fieldset >
                                        <FormGroup>
                                            <Label>First Name<span className="mandatory">*</span></Label>
                                            <Input name="Executors_First_Name" pattern="[a-zA-Z\s]+" type="text" id="Executors_First_Name" required />
                                            <FormFeedback>Please enter a name</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Surname<span className="mandatory">*</span></Label>
                                            <Input name="Executors_Sur_Name" pattern="[a-zA-Z\s]+" type="text" id="Executors_Sur_Name" required />
                                            <FormFeedback>Please enter a name</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Contact number<span className="mandatory">*</span></Label>
                                            <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Executors_Contact_Number" id="Executors_Contact_Number" required />
                                            <FormFeedback>Please enter a valid contact number</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                                <Label>Date of Birth<span className="mandatory">*</span></Label>
                                                <Input type="date" name="Executors_DOB" id="Executors_DOB" required />
                                                <FormFeedback>Please enter Date of Birth</FormFeedback>
                                            </FormGroup>
                                        <FormGroup>
                                            <Label>Email address<span className="mandatory">*</span></Label>
                                            <Input type="email" name="Executors_Email_Address" id="Executors_Email_Address" onChange={() => this.emailValue('Executors_Email_Address', 'Executors_Confirm_Email_Address')} required />
                                            <FormFeedback>Please enter a valid email address</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Confirm Email address<span className="mandatory">*</span></Label>
                                            <Input name="Executors_Confirm_Email_Address" type="email" id="Executors_Confirm_Email_Address" onChange={() => this.emailValue('Executors_Email_Address', 'Executors_Confirm_Email_Address')} required />
                                            {!this.state.isConfirmEmail && <span className="email_Error">Entered email address should be matching</span>}
                                            <FormFeedback>Please enter a valid email address</FormFeedback>

                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Please create a 4 digit pin</Label>
                                            <Input name="Executors_PIN" type="text" id="Executors_PIN" minLength="4" maxLength="4" pattern="^[0-9]*$" />
                                        </FormGroup>
                                        <p>
                                            Please choose a method of contact should we need to speak to you about the above details.
                                        </p>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="checkbox" value="call" name="Executor_Prefer_Contact_Type" /> Call
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="checkbox" value="email" name="Executor_Prefer_Contact_Type" /> Email
                                            </Label>
                                        </FormGroup>

                                        <div>
                                            {/* Declaration */}
                                            <h4>
                                                Declaration:
                                            </h4>

                                            <p className="justify-content"> I confirm that the information I've provided is true and accurate, and that I'm authorised to provide this information<br />
                                                and request these updates to the account. </p>

                                            <p className="justify-content">  Your personal data will be processed in accordance with eir’s privacy policy.</p>
                                            <p className="justify-content"> By clicking submit you confirm that you have read and understood this policy.</p>
                                        </div>
                                    </fieldset>
                                </div>
                            }
                            {/* Transfer Ownership */}
                            {this.state.transferAccount &&
                                <div>
                                    <Input type="hidden" value="Transfer Account Details:" id="Transfer_Sub_Heading" name="Transfer_Sub_Heading" />
                                    <fieldset disabled={this.state.isTransferAccountDisabled}>
                                        <FormGroup>
                                            <Label>First Name<span className="mandatory">*</span></Label>
                                            <Input name="Executors_First_Name" pattern="[a-zA-Z\s]+" type="text" id="Executors_First_Name" required />
                                            <FormFeedback>Please enter a name</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Surname<span className="mandatory">*</span></Label>
                                            <Input name="Executors_Sur_Name" pattern="[a-zA-Z\s]+" type="text" id="Executors_Sur_Name" required />
                                            <FormFeedback>Please enter a name</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Contact number<span className="mandatory">*</span></Label>
                                            <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Executors_Contact_Number" id="Executors_Contact_Number" required />
                                            <FormFeedback>Please enter a valid contact number</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                                <Label>Date of Birth<span className="mandatory">*</span></Label>
                                                <Input type="date" name="Executors_DOB" id="Executors_DOB" required />
                                                <FormFeedback>Please enter Date of Birth</FormFeedback>
                                            </FormGroup>
                                        <FormGroup>
                                            <Label>Email address<span className="mandatory">*</span></Label>
                                            <Input type="email" name="Executors_Email_Address" id="Executors_Email_Address" onChange={() => this.emailValue('Executors_Email_Address', 'Executors_Confirm_Email_Address')} required />
                                            <FormFeedback>Please enter a valid email address</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Confirm Email address<span className="mandatory">*</span></Label>
                                            <Input name="Executors_Confirm_Email_Address" type="email" id="Executors_Confirm_Email_Address" onChange={() => this.emailValue('Executors_Email_Address', 'Executors_Confirm_Email_Address')} required />
                                            {!this.state.isConfirmEmail && <span className="email_Error">Entered email address should be matching</span>}
                                            <FormFeedback>Please enter a valid email address</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Please create a 4 digit pin</Label>
                                            <Input name="Executors_PIN" type="text" id="Executors_PIN" minLength="4" maxLength="4" pattern="^[0-9]*$" />
                                        </FormGroup>
                                        <p>
                                            Please choose a method of contact should we need to speak to you about the above details.
                                        </p>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="checkbox" value="call" name="Executor_Prefer_Contact_Type" /> Call
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline>
                                            <Label check>
                                                <Input type="checkbox" value="email" name="Executor_Prefer_Contact_Type" /> Email
                                             </Label>
                                        </FormGroup>

                                        {/* New Account holders details */}
                                        <div>
                                            <h4>
                                                New Account holder’s details:
                                            </h4>
                                        </div>

                                        <FormGroup>
                                            <div className="d-flex ml-4 mt-2">
                                                <CustomInput onClick={this.formgreyout} name="Same_as_Transfer_Account_Details" value="true" type="checkbox" id="Same_as_Transfer_Account_Details" label={"Please tick this box if the details of the new account holder are the same as above."} />
                                            </div>
                                        </FormGroup>
                                        <fieldset disabled={this.state.isDisabled}>
                                            <FormGroup>
                                                <Label>First Name <span className="mandatory">*</span></Label>
                                                <Input name="Transfer_First_Name" pattern="[a-zA-Z\s]+" type="text" id="Transfer_First_Name" required />
                                                <FormFeedback>Please enter a name</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Surname<span className="mandatory">*</span></Label>
                                                <Input name="Transfer_Sur_Name" pattern="[a-zA-Z\s]+" type="text" id="Transfer_Sur_Name" required />
                                                <FormFeedback>Please enter a name</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Contact number<span className="mandatory">*</span></Label>
                                                <Input type="tel" minLength="6" maxLength="10" pattern="^[0-9-+s()]*$" name="Transfer_Contact_Number" id="Transfer_Contact_Number" required />
                                                <FormFeedback>Please enter a valid contact number</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Date of Birth<span className="mandatory">*</span></Label>
                                                <Input type="date" name="Transfer_DOB" id="Transfer_DOB" required />
                                                <FormFeedback>Please enter Date of Birth</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Email address<span className="mandatory">*</span></Label>
                                                <Input type="email" name="Transfer_Email_Address" id="Transfer_Email_Address" onChange={() => this.emailValue('Transfer_Email_Address', 'Transfer_Confirm_Email_Address')} required />
                                                <FormFeedback>Please enter a valid email address</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Confirm Email address<span className="mandatory">*</span></Label>
                                                <Input name="Transfer_Confirm_Email_Address" type="email" id="Transfer_Confirm_Email_Address" onChange={() => this.emailValue('Transfer_Email_Address', 'Transfer_Confirm_Email_Address')} required />
                                                {!this.state.isConfirmEmail && <span className="email_Error">Entered email address should be matching</span>}
                                                <FormFeedback>Please enter a valid email address</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Please create a 4 digit pin</Label>
                                                <Input name="Transfer_Pin_To_Verify" type="text" id="Transfer_Pin_To_Verify" minLength="4" maxLength="4" pattern="^[0-9]*$" />
                                            </FormGroup>
                                            <p>
                                                Please choose a method of contact should we need to speak to you about the above details.
                                            </p>
                                            <FormGroup check inline>
                                                <Label check>
                                                    <Input type="checkbox" value="call" name="Transfer_Prefer_Contact_Type" /> Call
                                                </Label>
                                            </FormGroup>
                                            <FormGroup check inline>
                                                <Label check>
                                                    <Input type="checkbox" value="email" name="Transfer_Prefer_Contact_Type" /> Email
                                                </Label>
                                            </FormGroup>
                                        </fieldset>
                                        {/* New account holder’s full address */}

                                        <h4>
                                            New account holder’s full address:
                                        </h4>

                                        This address will be used for billing purposes should the new account holder not be residing at the address

                                        <FormGroup>
                                            <div className="d-flex ml-4 mt-2">
                                                <CustomInput onClick={this.addressformgreyout} name="Same_as_Original_Billing_Address" value="true" type="checkbox" id="Same_as_Original_Billing_Address" label={"Please tick this box if the billing address remains the same as the original account holders."} />
                                            </div>
                                        </FormGroup>
                                        <fieldset disabled={this.state.isAddDisabled}>
                                            <FormGroup>
                                                <Label>Customer's address line 1<span className="mandatory">*</span></Label>
                                                <Input name="Transfer_Address_One" type="text" id="Transfer_Address_One" required />
                                                <FormFeedback>Please enter address line 1 </FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Customer's address line 2</Label>
                                                <Input name="Transfer_Address_Two" type="text" id="Transfer_Address_Two" />
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Town/City<span className="mandatory">*</span></Label>
                                                <Input name="Transfer_Town_City" type="text" id="Transfer_Town_City" required />
                                                <FormFeedback>Please enter Town/City</FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>County<span className="mandatory">*</span></Label>
                                                <Input name="Transfer_County" type="select" id="Transfer_County" required>
                                                <option value="">Select County</option>
                                                {CList != undefined &&
                                    (CList.map((name, i) => <option key={name.name}>{name.name}</option>,))
                                    }
                                                </Input>
                                                <FormFeedback>Please enter county </FormFeedback>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label>Eircode<span className="mandatory">*</span></Label>
                                                <Input name="Transfer_Eircode" type="text" id="Transfer_Eircode" minLength="7" maxLength="8" pattern="^[0-9a-zA-Z\s]*$" required />
                                                <FormFeedback>Please enter Eircode </FormFeedback>
                                            </FormGroup>
                                            </fieldset>
                                            <p>Would you like this number to be included in the National Directory under your name?</p>
                                            <FormGroup check inline>
                                                <Label check>
                                                    <Input type="radio" value="yes" name="Listed_in_National_Directory"  required /> Yes
                                                    <FormFeedback>Please choose one option</FormFeedback>
                                                </Label>
                                            </FormGroup>
                                            <FormGroup check inline>
                                                <Label check>
                                                    <Input type="radio" value="no" name="Listed_in_National_Directory" /> No
                                                </Label>
                                            </FormGroup>
                                            
                                            <FormGroup>
                                                <div className="d-flex ml-4 mt-2">
                                                    <CustomInput name="Unsubscribe_From_Promotional_Material" value="yes" type="checkbox" id="Unsubscribe_From_Promotional_Material" label={"Please tick this box if you do not want to receive promotional contact or material from eir."} />
                                                </div>
                                            </FormGroup>
                                        
                                        <div>
                                            {/* Declaration */}
                                            <h4>
                                                Declaration:
                                            </h4>
                                            <div>
                                                <p className="justify-content"> You accept and acknowledge that the above new account holder will now be the legal named owner of this
                                                Account Number going forward.</p>

                                                <p className="justify-content"> Please note that this is only a change in the customer name of the Account Number and that all other
                                                terms and conditions relating to the Account Number remain unchanged. In the event a service under this
                                                Account Number is still within its minimum term / period for the service, this same minimum term has now
                                                transferred to you as you are now named account holder for this Account Number. For the avoidance of doubt
                                                this transfer of customer name does not give rise to a new minimum term.</p>

                                                <p className="justify-content">You acknowledge that eir is transferring the customer name of the Account Number to you and that eir accepts no
                                                liability to any other third party as a result of transferring the customer name of the Account number to you.</p>
                                            </div>
                                            <FormGroup >
                                                <div >
                                                    {/* <CustomInput  required name="TransferCheckConfirm" value="true" type="checkbox" id="TransferCheckConfirm" label={"I confirm that the information I've provided is true and accurate,and that I'm authorised to provide this information and request these updates to the account."} />  */}
                                                    <div className="form-group">
                                                        <div>
                                                            <div className="custom-checkbox custom-control">
                                                                <Input required name="Declaration_Accepted" type="checkbox" id="Declaration_Accepted" className="custom-control-input" value="true" />
                                                                <label className="custom-control-label" htmlFor="Declaration_Accepted">I confirm that the information I've provided is true and accurate, and that I'm authorised to provide <br />this information and request these updates to the account.</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </FormGroup>
                                            <p className="justify-content">Your personal data will be processed in accordance with eir’s privacy policy.
                                             By clicking submit you confirm that you have read and understood this policy.</p>
                                        </div>
                                    </fieldset>
                                </div>


                            }

                        </div>

                        <div className="d-flex justify-content-start">
                            <EirRecaptcha />
                        </div>

                        <div className="mt-4 d-flex justify-content-center">

                            <EirButton
                                type="button"
                                text="Submit"
                                name="Submit"
                                value="Submit"
                                onClick={this.handleSubmit}
                            />
                        </div>
                    </Form>
                )
                }

                {(this.state.response != null && this.state.response.result.status == 'success') && (
                    <div className="form-success align-items-center">Form Submitted Successfully</div>
                )}

                {(this.state.response != null && (this.state.response.result.status == 'failure' || this.state.response == false)) && (
                    <div className="form-error align-items-center">Form Submitted Failed</div>
                )}
            </div>




        )
    }
}
export default EirOnlineMedicalForm
